// @flow

import get from 'lodash/get';
import type { RequestSearchAdsJobsApi } from '../../../types/jobs/RequestSearchAdsJobsApi';
import guardNegativeOrZeroNumber from '../../utils/guardNegativeOrZeroNumber';

type RequestData = {
  searchParams: Map<string, any>,
  trovit: Object,
  userId: ?string,
};

export default function map(
  requestData: RequestData,
  shouldResetWhere: boolean
): RequestSearchAdsJobsApi {
  const { searchParams, trovit, userId } = requestData;
  const origin = trovit.origin;

  return {
    pathParams: {
      countryCode: String(get(searchParams, 'country_code')),
      verticalName: String(get(searchParams, 'vertical_name')),
    },
    queryParams: {
      retrieveKeyword: Boolean(get(searchParams, 'retrieveKeywords')),
      boostAdsSince: get(searchParams, 'boost_ads_since'),
      what: String(get(searchParams, 'what_d', '')),
      where: shouldResetWhere ? '' : String(get(searchParams, 'where', '')),
      dealTypeId: Number(get(searchParams, 'type_id')),
      'page[size]': Number(get(searchParams, ['sections', 'organic'])),
      'page[organic][size]': Number(get(searchParams, ['sections', 'organic'])),
      'page[premium][size]': Number(get(searchParams, ['sections', 'premium'])),
      countryCode: String(get(searchParams, 'country_code')),
      device: 'mobile',
      clientId: 'pwa-mobile',
      originId: get(searchParams, 'origin'),
      suggester: get(searchParams, 'suggester'),
      'page[number]': get(searchParams, 'page') || 1,
      'abTest[id]': get(trovit, ['abTest', 'id']),
      'abTest[option]': get(trovit, ['abTest', 'option']),
      'abTest[platform]': get(trovit, ['abTest', 'platform']),
      sort: get(searchParams, 'sort'),
      userCampaignIds: get(searchParams, 'userCampaignIds'),
      'filters[region]': get(searchParams, ['filters', 'region']),
      'filters[city]': get(searchParams, ['filters', 'city']),
      'filters[cityArea]': get(searchParams, ['filters', 'city_area']),
      'filters[dateFrom]': get(searchParams, ['filters', 'date_from']),
      'filters[salaryMin]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'salary_min'])),
      'filters[salaryMax]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'salary_max'])),
      'filters[category]': get(searchParams, ['filters', 'category']),
      'filters[company]': get(searchParams, ['filters', 'company']),
      'filters[jobType]': get(searchParams, ['filters', 'job_type']),
      'filters[workingHours]': get(searchParams, ['filters', 'working_hours']),
      'filters[experienceMin]': get(searchParams, ['filters', 'experience_min']),
      'filters[telecommute]': get(searchParams, ['filters', 'telecommute']),
      'filters[latMin]': get(searchParams, ['filters', 'lat_min']),
      'filters[latMax]': get(searchParams, ['filters', 'lat_max']),
      'filters[longMin]': get(searchParams, ['filters', 'long_min']),
      'filters[longMax]': get(searchParams, ['filters', 'long_max']),
      'redirect[cookieId]': trovit.installationId,
      'redirect[trackingCode]': get(trovit, ['trackingCodes', `${origin}`]),
      'redirect[pageViewId]': trovit.pageviewId,
      'redirect[suggester]': null,
      'redirect[userId]': userId,
    },
  };
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchRequest/jobs/requestJobsMapper.js